<template><div class="admin-email">
  <template v-if="!sent">
    <p>Use the <em><b>mass email</b></em> function to send mass emails to all registered users of the remote diagnostics portal.</p>
    <p>Allowed text substitutions are: {{ subs.join(', ') }}.</p>
    <p><a href="https://www.markdownguide.org/cheat-sheet/" target="_blank">
      Click here to see a guide to writing Markdown.</a></p>
    Subject: <input v-model="subject" />
    <div class="binary">
      <textarea v-model="src" />
      <div v-html="html" />
    </div>
    <p><button @click="confirmSend=true">Send to All Active Users &gt;&gt;</button></p>
    <modal-dialog v-if="confirmSend" @close="confirmSend=false" :strong="true" class="diag-preview">
      <p>Are you sure you want to send this email to <em><b>all active users</b></em>
        of the remote diagnostics portal?</p>
      Subject: {{ subject }}
      <div class="preview" v-html="html" />
      <template v-if="apiref===null">
        <button @click="send">Yes, send</button>
        &nbsp;
        <button @click="confirmSend=false">No, cancel</button>
      </template>
      <Loading v-else />
      <p v-if="error" class="error">An error occurred while attempting to send the email.</p>
    </modal-dialog>
  </template>
  <template v-else>
    The following email <em><b>has been sent</b></em> to all active users of the remote diagnostics portal:
    <p>Subject: {{ subject }}</p>
    <div class="preview" v-html="html" />
    <button @click="cleanSlate">Write another email &gt;&gt;</button>
  </template>
</div></template>
<script>
import api from '../../api'
import Loading from '../Loading'
import marked from 'marked'
import ModalDialog from '../ModalDialog'
export default {
  name: 'admin-email',
  components: { Loading, ModalDialog },
  data() {
    return {
      src: `Hi $firstname,

A feature update was applied to the TMV Remote portal. Please visit https://remote.tmvcontrol.com/ui-dev/h/about for details.

Regards,

Isaac Sutherland  
Software Developer  
TMV Control Systems, Inc.  
isutherland@tmvcontrol.com`,
      confirmSend: false,
      error: null,
      sent: false,
      subs: [ '$firstname', '$lastname', '$email', '$username' ],
      apiref: null,
      subject: 'TMV Remote Release @',
    }
  },
  computed: {
    html() { return marked(this.src) },
  },
  watch: {
    confirmSend(nv,ov) {
      this.error = null
      if (ov && !nv && this.apiref !== null) {
        this.apiref.cancel()
        this.apiref = null
      }
    },
  },
  methods: {
    async send() {
      try {
        let ref = this.apiref = { subject: this.subject, text: this.src, html: this.html }
        await api.sendMassEmail(ref)
        this.sent = true
        this.confirmSend = false
        this.error = null
      } catch(e) {
        if (!(e instanceof api.Canceled)) {
          this.error = e
          console.error(e)
        }
      } finally {
        this.apiref = null
      }
    },
    cleanSlate() {
      this.sent = false
      this.src = ''
    },
  },
}
</script>
<style lang="scss">
  .admin-email {
    .preview {
      border: 1px solid #000;
      padding: 10px;
      background: #fff;
      margin: 10px 0;
    }
    .binary {
      display: flex;
      textarea {
        width: 40%;
        margin-right: 20px;
        min-height: 200px;
      }
      > div {
        @extend .preview;
        flex-grow: 1;
      }
    }
    .diag-preview > div {
      max-width: 900px;
    }
  }
</style>
